import URLParser from '../URLParser'

const referrerIsSameAsSite = () => {
  return traffic => {
    if (traffic.referrer === '') {
      return false
    }
    const urlObject = new URLParser(traffic.url)
    const referrerObject = new URLParser(traffic.referrer)
    return urlObject.hostname === referrerObject.hostname
  }
}

export default referrerIsSameAsSite



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/referrerIsSameAsSite.js